<template>
    <Card :title="$t('labels.exit_declaration_status')">
        <div class="card-body">
            <ExitDeclarationStatusFieldsetGroup :exit-declaration-status="exitDeclarationStatus" />
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton size="sm" color="teal" @click="create">
                <span>{{ $t('buttons.create') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import ExitDeclarationStatusFieldsetGroup from './fieldsets/ExitDeclarationStatusFieldsetGroup.vue';
import { httpClient } from '../../../../services/HttpClient';
export default {
    name: "CreateExitDeclarationStatusPage",
    components: {
        Card, AppButton, ExitDeclarationStatusFieldsetGroup
    },
    data() {
        return {
            exitDeclarationStatus: {
                uuid: null,
                name: '',
                type: '',
                color: '',
                order: 0
            }
        }
    },
    methods: {
        async create() {
            await httpClient.post('/management/exit-declaration-statuses', {
                name: this.exitDeclarationStatus.name,
                color: this.exitDeclarationStatus.color,
                type: this.exitDeclarationStatus.type,
                order: this.exitDeclarationStatus.order
            }).then((response) => {
                this.$router.push({ name: 'EditExitDeclarationStatusPage', params: { exitDeclarationStatusUuid: response.data.data.uuid } });
            });
        }
    }
}
</script>
